import { useTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { ReactComponent as IconMinus } from '../../assets/icons/minus.svg';
import { ReactComponent as IconPlus } from '../../assets/icons/plus.svg';
import { IconButton } from '../IconButton';
import { Spacer } from '../Spacer';
import { Typography } from '../Typography';

const NumberSelect = ({ label, value, onIncrease, onDecrease, min, max }) => {
  const theme = useTheme();

  return (
    <Spacer style={{ alignItems: 'center', justifyContent: 'space-between' }} wrap>
      <Typography
        style={{
          fontWeight: theme.fontWeights.medium,
          color: theme.colors.secondaryTextColour,
        }}
      >
        {label}
      </Typography>
      <Spacer
        centered
        style={{
          border: `1px solid ${theme.colors.outlineColour}`,
          padding: '8px 12px',
          borderRadius: '6px',
          width: '132px',
          justifyContent: 'space-between',
        }}
      >
        <Typography>{value === 0 ? 'None' : value}</Typography>
        <Spacer>
          <IconButton
            disabled={min !== null && value <= min}
            variant='outlined'
            onClick={onDecrease}
          >
            <IconMinus />
          </IconButton>
          <IconButton
            disabled={max !== null && value >= max}
            variant='outlined'
            onClick={onIncrease}
          >
            <IconPlus />
          </IconButton>
        </Spacer>
      </Spacer>
    </Spacer>
  );
};

NumberSelect.defaultProps = {
  label: null,
  value: null,
  min: 0,
  max: null,
};

NumberSelect.propTypes = {
  label: PropTypes.string,
  value: PropTypes.number,
  onIncrease: PropTypes.func.isRequired,
  onDecrease: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
};

export default NumberSelect;
